import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-publish",
  "use": "icon-publish-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-publish\"><path d=\"M23.2 347.2c-52.4 16.8 0.4 66.4 0.4 66.4l176.8 147.6 550.8-326c0 0-372 286.4-485.6 375.2l383.6 290c60.8 40 76.4 8 76.4 8l26.8-63.2 270.4-752.4c10-26-18.4-56-49.2-51.2L23.2 347.2 23.2 347.2M414.8 787.6l-146.8-109.6-0.4 212L414.8 787.6 414.8 787.6M414.8 787.6\" p-id=\"4303\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol